import env from 'src/env'

import * as deepExtend from 'deep-extend'

if (env.env !== 'deploy') {
    console.log('version:' + env.version)
}

export default deepExtend(env, {
    // 默认头像
    defaultHeadImg: 'assets/image/default.png',
    // 获取微信api接口的url
    // 问候
    dayRange: {
        '0': '今天',
        '1': '昨天',
        '2': '前天'
    },
    // 问候
    greet: {
        '6': '凌晨好！',
        '9': '早上好！',
        '12': '上午好！',
        '14': '中午好！',
        '17': '下午好！',
        '19': '傍晚好！',
        '24': '晚上好！'
    },
    // 理明接口所有的审核英文--中文
    verify: {
        'none': '未反馈报告，去维护',
        'missing': '缺失',
        'approved': '审核通过(未归档)',    // 审核通过(未归档)
        'archived': '已归档',        // 已反馈报告，审核通过(已归档)
        'rejected': '审核不通过',    // 已反馈报告，审核不通过
        'committed': '待审核'        // 已反馈报告，未评审
    },
    // 理明接口所有的审核英文--中文  ---仅仅针对的是项目
    verifyCheck: {
        'missing': '待整改',
        // 'archived': '复验通过',        // 已反馈报告，审核通过(已归档)
        'archived': '已完成',        // 已反馈报告，审核通过(已归档)
        'committed': '待复验'        // 已反馈报告，未评审
    },
    // 报告列表的状态显示
    state: {
        'none': '编辑报告',
        'missing': '编辑报告',
        'approved': '审核报告',
        'archived': '查看报告',
        'rejected': '编辑报告',
        'committed': '编辑报告'
    },
    // 报告状态的图标的名称
    iconName: {
        'none': 'iconEdit',
        'missing': 'iconEdit',
        'approved': '',
        'archived': 'check',
        'rejected': 'iconEdit',
        'committed': 'iconEdit'
    }
})



// WEBPACK FOOTER //
// ./src/common/config/index.js